import { baseActions, baseMutations } from '../base'
import { apiAxios } from '@/helpers'
import { formatDate } from '@/helpers/dateHelper'
import i18n from '@/i18n/i18n'

const initialState = () => {
  return {
    module: 'roles',
    model: 'role',
    loading: false,
    list: [],
    selectList: [],
    permissionList: [],
    selected: {
      active: true,
      name: [],
      description: [],
      type: '',
      permissions: [],
      isDefault: false,
    },
    idSelected: '',
    types: [
      'familiar',
      'coordinatorTournament',
      'player',
      'trainer',
      'coordinator',
      'president',
      'fan',
      'support',
      'all',
    ],
    pagination: {
      hasMore: false,
      page: 1,
      rowsPerPage: 0,
      totalItems: 0,
    },
  }
}

const state = initialState()

const getters = {
  roleTypes(state) {
    return state.types.map((item) => ({
      value: item,
      text: i18n.t(`titles.roles.${item}`),
    }))
  },
  selectList(state) {
    return state.selectList
  },
  selectListFiltered(state, getters, rootState) {
    const is = (type) =>
      rootState.auth.roles.some(
        (item) => item.confirm && item.roleId && item.roleId.type === type
      )

    return state.selectList.filter((role) => {
      if (is('all')) {
        return role.type !== 'fan'
      } else if (is('president')) {
        return ['coordinator', 'trainer', 'player', 'familiar'].includes(
          role.type
        )
      } else if (is('coordinator')) {
        return ['trainer', 'player', 'familiar'].includes(role.type)
      } else if (is('trainer')) {
        return ['player', 'familiar'].includes(role.type)
      } else return true
    })
  },
  permissionSelectList(state) {
    return state.permissionList
  },
  formatedList(state, getters) {
    return state.list.map((item) => {
      let result = {
        _id: item._id,
        active: item.active,
        name: item.name,
        description: item.description,
        type: item.type,
        createdAt: formatDate(item.createdAt, true),
        createdBy: item.createdBy
          ? item.createdBy.name + ' ' + item.createdBy.lastname1
          : '-',
      }
      const type = getters.roleTypes.find((type) => type.value === item.type)
      result.type = type ? type.text : '-'

      result.permissions = item.permissions.map((permission) => permission.name)

      return result
    })
  },
}

const actions = {
  ...baseActions,
  async fetchPermissionList({ commit }, params = {}) {
    const { data } = await apiAxios.post('permissions/select', params, {
      params: { limit: 0 },
    })
    const list = data.data ? data.data['permission'] : []
    commit('setPermissionList', list)
  },
  async fetchSelectList({ commit, state }) {
    if (state.selectList.length) return
    commit('setLoading', true)
    const { data } = await apiAxios
      .post(state.module + '/select', {}, { params: { limit: 0 } })
      .finally(() => commit('setLoading', false))
    const list = data.data
      ? data.data[state.model] || data.data[state.module]
      : []

    commit('setSelectList', list)

    return list
  },
}

const mutations = {
  ...baseMutations,
  setPermissionList(state, payload) {
    state.permissionList = payload || []
  },
  resetState(state) {
    const newState = initialState()
    Object.keys(state).forEach((key) => {
      delete state[key]
    })
    Object.assign(state, newState)
  },
  reset(state) {
    state.selected = initialState().selected
    state.idSelected = ''
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
